import { PageLayout } from '@/components/UI/Layouts/Admin/PageLayout';
import { ROUTES } from '@/config/routes';
import { useCreateOne } from '@/queries/admin';
import toast from 'react-hot-toast';
import { useNavigate } from 'react-router-dom';
import { Form, FormData } from './Form';

export const Create = () => {
  const navigate = useNavigate();
  const { mutateAsync: createChatGroup } = useCreateOne('chat-groups');

  const onSubmit = async (data: FormData) => {
    try {
      await createChatGroup({ data });
      toast.success('Группа чатов успешно создана');
      navigate(ROUTES.ADMIN.CHATS_GROUPS);
    } catch (error) {
      console.error('Error creating chat group:', error);
      toast.error('Произошла ошибка при создании группы чатов');
    }
  };

  return (
    <PageLayout
      breadcrumbs={[
        { label: 'Группы чатов', href: ROUTES.ADMIN.CHATS_GROUPS },
        { label: 'Создание', href: '' },
      ]}
    >
      <Form onSubmit={onSubmit} />
    </PageLayout>
  );
};
